import { MONTHLY_MULTIPLIER_KEYS } from 'types';
import type { MonthlyMultipliers } from 'types';

export type MonthKey = keyof MonthlyMultipliers;

/** Twelve whole-percent multipliers summing to this average 100%/month, so the year costs the same as a flat plan. */
export const ANNUAL_EQUIVALENT_TOTAL = 1200;

export const MONTH_KEYS = MONTHLY_MULTIPLIER_KEYS;

export const MONTH_LABELS: Record<MonthKey, string> = {
  jan: 'January',
  feb: 'February',
  mar: 'March',
  apr: 'April',
  may: 'May',
  jun: 'June',
  jul: 'July',
  aug: 'August',
  sep: 'September',
  oct: 'October',
  nov: 'November',
  dec: 'December',
};

/** Tolerates the blank/partial strings a month input holds mid-edit so the running total stays a number. */
export const sumMultipliers = (multipliers: Record<MonthKey, string | number>): number =>
  MONTH_KEYS.reduce((total, key) => total + (Number(multipliers[key]) || 0), 0);

export const seasonalPlansPath = (programType: string) => `/admin/pricing/${programType}/seasonal-plans`;

// Fixed regardless of theme: the chip/badge/bar backgrounds these sit on don't
// change between light and dark mode, so the colors themselves don't need to either.
export const ORANGE_CELL = '#fff5da'; // brand-orange-50  (>100%)
export const BLUE_CELL = '#cce5ff'; // badge-info-bg    (<100%)
export const ORANGE_BAR = '#ffaf1a'; // brand-orange-400
export const BLUE_BAR = '#2692ff'; // brand-secondary-400
